import React from 'react';
import RedemptionCard from './components/RedemptionIndex.jsx';

const Redemption = () => <RedemptionCard />;

export default Redemption;
